import { Heading, PrimaryButton } from 'Components/_theme'

import { NewPhonePlanModal } from 'Modals/NewPhonePlanModal/NewPhonePlanModal'

import { PageTypeEnum } from 'Types/page/page.types'

import { useModal } from 'Portal/src/hooks'

export const NewPhonePlanModalPresentation = () => {
  const { setModal, hideModal } = useModal()

  const openNewPhonePlanModal = () => {
    setModal({
      component: NewPhonePlanModal,
      isOpen: true,
      props: {
        handleSubmit: () => {
          hideModal()
        },
        hide: hideModal,
        page: PageTypeEnum.Overview,
      },
    })
  }

  return (
    <div>
      <Heading className="pt-4" size={4}>
        Modal:
      </Heading>
      <div className="pt-4">
        <PrimaryButton onClick={openNewPhonePlanModal}>
          New Phone Plan
        </PrimaryButton>
      </div>
    </div>
  )
}
